// extracted by mini-css-extract-plugin
export var externalLink = "_cb-0";
export var internalLinkLabel = "_cb-1";